<template>
    <div class="ls-image-row--container">
        <div v-if="fullScreen" class="ls-image-row--overlay" test-id="overlay">
            <div class="ls-image-row--top">
                <span class="ls-image-row--title">{{ images[currentImage].title }}</span>
                <LsIcon
                    type="close"
                    size="xlg"
                    color="white"
                    class="ls-image-row--close"
                    test-id="close"
                    @click.native="close"
                />
                <div class="ls-image-row--full-image-container">
                    <img
                        :src="images[currentImage].image_url"
                        test-id="full-image"
                        class="ls-image-row--full-image"
                    />
                </div>
            </div>

            <div>
                <LsIcon
                    type="chevron"
                    size="xlg"
                    color="white"
                    :class="['ls-image-row--chevron left', { disable: !currentImage }]"
                    test-id="left"
                    @click.native="changeImage(currentImage - 1)"
                />
                <LsIcon
                    type="chevron"
                    size="xlg"
                    color="white"
                    :class="['ls-image-row--chevron', { disable: currentImage === lastIndex }]"
                    test-id="right"
                    @click.native="changeImage(currentImage + 1)"
                />
            </div>
        </div>
        <div class="ls-image-row--row">
            <img
                v-for="(image, idx) in firstThreeImages"
                :key="image.id"
                class="ls-image-row--thumbnail"
                :src="image.thumbnail_url"
                test-id="thumbnails"
                @click="openImage({ idx })"
            />
            <a v-if="lastIndex >= 3" test-id="view_all" @click="openImage({ idx: 0 })">View All</a>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { LsIcon } from '@/components/common';

export default {
    name: 'LsImageRow',
    components: {
        LsIcon,
    },
    props: {
        images: VueTypes.arrayOf(
            VueTypes.shape({
                id: VueTypes.string.isRequired,
                title: VueTypes.string,
                image_url: VueTypes.string.isRequired,
                thumbnail_url: VueTypes.string.isRequired,
            }).loose
        ).isRequired,
    },
    data() {
        return {
            fullScreen: false,
            currentImage: 0,
        };
    },
    computed: {
        lastIndex() {
            return _.size(this.images) - 1;
        },
        firstThreeImages() {
            return this.images.slice(0, 3);
        },
    },
    methods: {
        openImage({ idx }) {
            this.fullScreen = true;
            this.currentImage = idx;
        },
        changeImage(img) {
            if (img < 0 || img > this.lastIndex) {
                return;
            }
            this.currentImage = img;
        },
        close() {
            this.fullScreen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-image-row--container {
    margin-bottom: 15px;
}

.ls-image-row--overlay {
    position: fixed;
    top: $navbar-height;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(61, 68, 101, 0.9);
    z-index: $z-index-image-overlay;
}

.ls-image-row--top {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
}

.ls-image-row--title {
    padding-bottom: 15px;
    font-size: 1.8rem;
    color: $white;
    font-weight: $medium;
}

.ls-image-row--close {
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: -5px;

    &:hover {
        opacity: 0.8;
    }
    &:active {
        opacity: 1;
    }
}

.ls-image-row--full-image-container {
    display: flex;
    justify-content: center;
}

.ls-image-row--full-image {
    max-height: 70vh;
    max-width: 1000px;
    object-fit: scale-down;
    @media (max-width: $tablet-max-width) {
        max-width: 700px;
    }
}

.ls-image-row--chevron {
    margin: 20px 10px 10px 10px;
    cursor: pointer;

    &.left {
        transform: rotate(-180deg);
    }
    &:hover {
        opacity: 0.8;
    }
    &:active {
        opacity: 1;
    }
    &.disable {
        opacity: 0.5;
        cursor: default;
    }
}

.ls-image-row--row {
    display: flex;
    img:not(:last-child) {
        margin-right: 10px;
    }

    a {
        display: flex;
        align-items: flex-end;
    }
}

.ls-image-row--thumbnail {
    object-fit: cover;
    cursor: pointer;
    user-select: none;
    width: 70px;
    height: 70px;
}
</style>
